<h2 mat-dialog-title>{{ data.title ?? 'Create product' }}</h2>

<mat-dialog-content>
  <div class="entity-form">
    <mat-form-field>
      <mat-label>Client Code</mat-label>
      <input matInput [formField]="form.ClientCode" [matAutocomplete]="ccAutocomplete.autocomplete()" #ccInput />
      <lcm-autocomplete #ccAutocomplete="lcmAutocomplete" [options]="clientCodes()" [pattern]="ccInput.value" />
    </mat-form-field>

    <mat-form-field>
      <mat-label> Title </mat-label>
      <input matInput [formField]="form.Title" />
    </mat-form-field>

    <mat-form-field>
      <mat-label> Product Owner </mat-label>

      <input matInput [formField]="form.ProductOwner" [matAutocomplete]="poAutocomplete.autocomplete()" #poInput />
      <lcm-autocomplete #poAutocomplete="lcmAutocomplete" [options]="productOwners()" [pattern]="poInput.value" />
    </mat-form-field>

    <mat-form-field>
      <mat-label> Status </mat-label>
      <mat-select [formField]="form.Status">
        @for (code of statusOptions(); track code) {
          <mat-option [value]="code">{{ code }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-checkbox [formField]="form.Commissionable">Commissionable</mat-checkbox>

    <mat-form-field>
      <mat-label> Notes </mat-label>
      <textarea matInput [formField]="form.Notes"></textarea>
    </mat-form-field>

    <mat-form-field>
      <mat-label> Hours/budget note </mat-label>
      <input matInput [formField]="form.BudgetNote" />
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button matMiniFab matTooltip="Save product details" (click)="save()" [disabled]="!form().valid() || pending()">
    <mat-icon>save</mat-icon>
  </button>
</mat-dialog-actions>
@if (pending()) {
  <mat-progress-bar mode="indeterminate" />
}
